import { Helmet } from 'react-helmet-async'

export default function DisclaimerPage() {
  return (
    <>
      <Helmet>
        <title>Disclaimer | AzureCalc.uk</title>
        <meta name="description" content="Full legal disclaimer for AzureCalc.uk cost estimates. Learn about our data sourcing from the Azure Retail Prices API and our independent affiliate disclosure." />
        <link rel="canonical" href="https://www.azure-calc.co.uk/disclaimer" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebApplication",
          "name": "AzureCalc.uk Disclaimer",
          "description": "Legal disclaimer and data sourcing information for AzureCalc.uk",
          "url": "https://www.azure-calc.co.uk/disclaimer",
          "applicationCategory": "FinanceApplication",
          "operatingSystem": "Web"
        })}</script>
      </Helmet>
      <div className="px-6 py-6 w-full">
        <div className="pb-6 mb-8" style={{ borderBottom: '1px solid var(--outline-variant)' }}>
          <h1 className="text-xl font-semibold" style={{ color: 'var(--text-primary)' }}>
            Disclaimer
          </h1>
        </div>
        
        {/* Full disclaimer from CLAUDE.md Section 7 */}
        <div className="disclaimer-block mb-6">
          <p>Cost estimates provided by this tool are approximations 
          only and are not intended as actual price quotes. Prices 
          are sourced from the Microsoft Azure Retail Prices API and 
          are updated nightly. Actual Azure costs may vary based on 
          the terms of your Microsoft agreement, reserved instance 
          pricing, enterprise discounts, commitment plans, currency 
          exchange rates, and regional availability changes. This 
          tool is not affiliated with, endorsed by, or sponsored by 
          Microsoft Corporation. Always verify pricing through the 
          official Azure Pricing Calculator at{' '}
          <a href="https://azure.microsoft.com/pricing/calculator"
             target="_blank" rel="noopener noreferrer"
             className="text-[#0078d4] hover:underline">
            azure.microsoft.com/pricing/calculator
          </a>{' '}
          before making purchasing decisions.</p>
        </div>

        {/* Logic Apps specific disclaimer from CLAUDE.md Section 7 */}
        <h2 className="text-base font-semibold mb-3" style={{ color: 'var(--text-primary)' }}>
          Note on Logic Apps Action Execution Counting
        </h2>
        <div className="disclaimer-block mb-6">
          <p>Azure Logic Apps bills each trigger check, action step, 
          retry attempt, and loop iteration as a separate execution. 
          Actual costs may differ significantly from estimates if your 
          workflows contain loops, conditions, or frequent retry 
          scenarios.</p>
        </div>

        {/* Affiliate disclosure */}
        <h2 className="text-base font-semibold mb-3" style={{ color: 'var(--text-primary)' }}>
          Affiliate Links
        </h2>
        <div className="disclaimer-block">
          <p>Some links on this website are affiliate links marked
          with "AD". A commission may be earned if you purchase
          through these links, at no extra cost to you. This does not
          influence the estimates or recommendations on this site. All
          affiliate relationships comply with UK ASA/CAP guidelines.</p>
        </div>
      </div>
    </>
  )
}
